module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-b8b3a8b2a0e28b46fe6de1ad18aa1d3a.svg";